import React, { Component } from 'react';
import CollectionBrowser from "./../../components/collectionBrowser";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Flodeskform from "./../../components/flodeskForm";
import FullWidthPortfolioTeaser from "./../../components/fullWidthPortfolioTeaser";
import {Stories} from "./../../utils/stories";
import {BookstoreBookLink, PrimaryBookLink, PrimaryReviewLink} from "./../../utils/constants";
import { withController, Parallax } from 'react-scroll-parallax';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";

class Home extends Component {
  render() {
    return (
      <div className="full-height full-width">
        <Helmet>
          <title>{'The Joys of Jet Lag | How to Use a Traveler’s Mindset to Not be an A-Hole in Daily Life'}</title>
          <meta name="description" content="The Joys of Jet Lag guides readers on a journey to discover how to use a traveler's mindset to craft joy in daily life. Written by Kat Medina." />
        </Helmet>
        <BannerFadeIn>
          <div className="threeQuarter-height full-width black-background background-image-fill centered-text" style={{backgroundImage:"url(/images/blog-joy.jpg)", height:'50vh'}}>
          </div>
        </BannerFadeIn>
        <ScrollFadeIn>
          <div className="centered-text">
            <div className="text-max-width-container">
              <img style={{width:"100%", maxWidth:900, margin:'auto',marginTop:'-40vh'}} src="/images/book-cover-angle.png" />
              <div className="centered-text tiny-padding" stye={{marginTop:-20, margin:'auto'}}>
                <div className="row">
                  <div className="small-12 medium-6">
                    <div className="tiny-padding">
                      <a target="_blank" href={BookstoreBookLink}>
                        <div className="button primary-background white full-width">{'Buy on Bookshop.org'}</div>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-6">
                    <div className="tiny-padding">
                      <a target="_blank" href={PrimaryBookLink}>
                        <div className="button primary-background white full-width">{'Buy on Amazon.com'}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <h1>{'Live your best life, no matter where you are.'}</h1>
            </div>
          </div>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <div className="large-padding" style={{paddingTop:0}}>
            <div className="text-max-width-container">
              <p className="tiny-padding">{'Do you find it easy to experience wholehearted adventure and joy when you’re on vacation, but you’re a total stress case in everyday life?'}</p>
              <p className="tiny-padding">{'The Joys of Jet Lag is your guidebook to using a traveler’s mindset to navigate a life of joy. By breaking free from asshole-autopilot, you’ll reawaken to the wonder around you, embrace challenges as part of the adventure, and trust that life is always happening for you, not to you.'}</p>
              <p className="tiny-padding" style={{paddingBottom:0}}>{'At the end of this book, you’ll know how to:'}</p>
              <ul>
                <li><p>{'Uncover the joy-boosting opportunities hidden beneath the mundane moments.'}</p></li>
                <li><p>{'Find the humor and annoyingly subtle lessons in life’s Category 5 turd tornadoes.'}</p></li>
                <li><p>{'Let go of the bullshit stories that are holding you back from the joy you deserve.'}</p></li>
                <li><p>{'Silence doubt and pursue the daring life you were born to live.'}</p></li>
                <li><p>{'With captivating travel stories, simple exercises, and refreshingly real self-help advice without any of the rah-rah, this hilarious how-to guide will help you discover the keys to living your best life with no passport required.'}</p></li>
                <li><p>{'Check out excerpts from The Joys of Jet Lag below.'}</p></li>
              </ul>
            </div>
          </div>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <div className="large-padding" style={{paddingTop:0}}>
            <div className="centered-text full-width">
              <img style={{width:200, height:200, borderRadius:'50%', marginBottom:-50}} src="/images/ashleigh.jpg" />
            </div>
            <div className="text-max-width-container primary-background white small-padding centered-text">
              <h4 className="tiny-padding">{' “The Joys of Jet Lag offers a roadmap for how we can truly change the quality of our lives. Joy seekers, unite! Kat Medina shows readers how to travel to new heights of happiness.”'}</h4>
              <p className="tiny-padding">{' –Ashleigh Renard, author of Swing and Keeping it Hot: The Workbook'}</p>
            </div>
          </div>
        </ScrollFadeIn>
        <div className="max-width-container">
          {Stories.map((story, i) => {
            let direction = "right";
            if(i % 2 != 0){
              direction = "left";
            }
            return (
              <div key={i} className="tiny-padding">
                <FullWidthPortfolioTeaser
                  direction={direction}
                  title={story.title}
                  subtitle={story.subtitle}
                  description={story.description}
                  backgroundImage={story.backgroundImage}
                  link={story.link}
                 />
              </div>
            );
          })}
        </div>
        <ScrollFadeIn>
          <Flodeskform />
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}

export default withController(Home);



// WEBPACK FOOTER //
// ./src/pages/joys/index.js